import * as React from 'react';
import {
  IProfileReportSettingsState,
  profileReportSettingsProvider,
} from '../../../data/providers/settings/reports/profileReportSettingsProvider';
import { Entity, EntityType } from '../../../data/types';
import { LinearLoading } from '../../shared/loading/LinearLoading';
import { EPdfMode } from '../../shared/pdf/Pdf';
import { ZScoreReport } from './sessions/ZScoreReport';
import { RadarReport } from './single/RadarReport';

interface IProps {
  pdfMode?: EPdfMode;
  entity: Entity;
  entityType: EntityType;
  onPdfModeChange: (pdfMode: EPdfMode) => void;
  loading: boolean;
  setLoading: (v: boolean) => void;
}

export const ProfileReport = (props: IProps): React.ReactElement => {
  const [settings, setSettings] = React.useState<IProfileReportSettingsState>();
  const [settingsLoading, setSettingsLoading] = React.useState<boolean>(true);

  /**
   * @description subscribe to report settings
   */
  React.useEffect((): (() => void) => {
    const subscriber = profileReportSettingsProvider().subscribe(
      (state: IProfileReportSettingsState): void => {
        setSettings(state);
        setSettingsLoading(false);
      }
    );
    return (): void => subscriber.unsubscribe();
  }, []);

  const showBars = settings?.graph?.value === 'bar';

  return settingsLoading ? (
    <LinearLoading />
  ) : settings ? (
    showBars ? (
      <ZScoreReport {...props} />
    ) : (
      <RadarReport {...props} />
    )
  ) : null;
};
